const DEFAULT_TOAST_DURATION = 2000;

const clearTimer = timerId => {
  if (!timerId) return 0;
  clearTimeout(timerId);
  return 0;
};

/** 短时 Toast：重复 show 会重置计时 */
export default {
  data() {
    return {
      paytypeToastText: '',
      _paytypeToastTimer: 0
    };
  },
  beforeDestroy() {
    this.hidePaytypeToast();
  },
  methods: {
    hidePaytypeToast() {
      this._paytypeToastTimer = clearTimer(this._paytypeToastTimer);
      this.paytypeToastText = '';
    },
    showPaytypeToast(message, duration = DEFAULT_TOAST_DURATION) {
      this.paytypeToastText = message || '';
      this._paytypeToastTimer = clearTimer(this._paytypeToastTimer);
      if (!this.paytypeToastText || duration <= 0) return;
      this._paytypeToastTimer = setTimeout(() => {
        this.paytypeToastText = '';
        this._paytypeToastTimer = 0;
      }, duration);
    }
  }
};
